module.exports = __webpack_public_path__ + "img/64_4.c433b5d7.png";